import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

const Heading = ({ rendering, fields, params }: ComponentProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { sitecoreContext } = useSitecoreContext();

  return (
    (sitecoreContext.pageEditing || fields?.header?.value) && (
      <div>
        <div id={anchorId} className="mt-5 mb-2">
          <Text tag={params.type} className="background-to-change" field={fields.header} />
        </div>
      </div>
    )
  );
};

export default Heading;
